import axios, { AxiosInstance } from 'axios';
import { useGraphqlContext } from '../../context/graphql';
import { useInstallationContext } from '../../context/installation';
import { Api, HttpClient } from '../../integrations/lavva/types/openapi/openapi-types';
import { useAuth } from '../../hooks/auth/use-auth';
import { isLocalApp } from '../helpers/local-app';

class CustomHttpClient<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  constructor(axiosInstance: AxiosInstance) {
    super();
    this.instance = axiosInstance;
  }
}

type RestClientParams = {
  noInstallationIdHeader?: boolean;
};

export const useRestClient = (params?: RestClientParams): AxiosInstance => {
  return !isLocalApp ? useRest(params) : useRestLocal();
};

export const useRest = (params?: RestClientParams): AxiosInstance => {
  const { keycloak } = useAuth();
  const { selectedInstallationId } = useInstallationContext();
  const { LAVVA_MANAGER } = useGraphqlContext();

  return axios.create({
    baseURL: LAVVA_MANAGER,
    headers: {
      'Content-type': 'application/json',
      ...(!params?.noInstallationIdHeader ? { installationId: selectedInstallationId || '' } : {}),
      ...(keycloak.token ? { Authorization: `Bearer ${keycloak.token}` } : {}),
    },
  });
};

export const useRestLocal = (): AxiosInstance => {
  return axios.create();
};

export const useHttpClient = (params?: RestClientParams) => {
  const instance = !isLocalApp ? useRest(params) : useRestLocal();
  return new Api(new CustomHttpClient(instance));
};
